
export const isRequired = (field, value) => {
  if (!value) {
    return `${field} is required`
  }
  return ''
}

export const hasLength = (field, value, length) => {
  if (value && value.length < length) {
    return `${field} should have minimum length of ${length}`
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/lib/formWatchers.js